import React, { Component } from 'react';
import { Input, Tooltip, Button, Checkbox, Modal, Row, Col, Dropdown, Icon, Menu, Collapse, Form, Select, Radio, DatePicker, Spin } from 'antd';
import { compose } from 'recompose';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment'
import './editalumni.css';
import InputMask from 'react-input-mask'
import Skeleton from 'react-loading-skeleton';


const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const Panel = Collapse.Panel;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const { Option } = Select;

const customPanelStyle = {
    background: '#fff',
    borderRadius: 16,
    boxShadow: '0 7px 64px 0 rgb(0 0 0 / 7%)',
    marginBottom: 24,
    border: 0,
    overflow: 'hidden',
};


class AlumniInfoForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            forceRender: true,
            isInEditMode: false,
            firstName: '',
            middleName: '',
            lastName: '',
            nickName: '',
            dateOfBirth: '',
            gender: '',
            personGUID: '',
            scouts_DOB_MaskChar: null,
            IsFutureDate: false,
            CustomDateErrMsg: '',
        }

    }
    
    maxLength  = 100;

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleButtonClick(e) {
        console.log('click left button', e);
    }

    formatDateOfBirth = (e) => {
        let val = e.target.value.split('/');
        let NumExp = /[0-9]/
        val[0] = NumExp.test(val[0]) ? val[0].startsWith('-') ? val[0].replace("-", '0') : val[0] : '';
        val[1] = NumExp.test(val[1]) ? val[1].startsWith('-') ? val[1].replace("-", '0') : val[1] : '';
        val = val.toString().replaceAll(',', '/')

        // console.log("val final " + val);
        // let g = this.props.form.getFieldValue('scout_dob');
        // console.log("getFieldValue " + g);
        setTimeout(() => {
            this.props.form.setFieldsValue({
                scout_dob: val,
            });
        }, 0)
        this.setState({
            scouts_DOB: val
        })

    }

    renderGender = () => {
        if (this.props.genders) {
            let gendersarray = this.props.genders
            return gendersarray.map((k, index) => {
                return (
                    <Radio value={k.short}>{k.name}</Radio>
                )
            })
        }
    }

    renderEthnicity = () => {
        if (this.props.ethnicities && Array.isArray(this.props.ethnicities) && this.props.ethnicities.length > 0 && !this.props.ethnicities_loading) {
            return this.props.ethnicities.map(ethnicity => <Option key={ethnicity.id} value={ethnicity.short}>{ethnicity.name}</Option>)
        } 
    }

    renderprefix = () => {
        if (this.props.prefixes) {
            let prefixesarray = this.props.prefixes
            return prefixesarray.map((k, index) => {
                return (
                    <option key={index} value={k.name}>{k.name}</option>
                )
            })
        }
    }

    rendersuffix = () => {
        if (this.props.suffixes) {
            let suffixesarray = this.props.suffixes
            return suffixesarray.map((k, index) => {
                return (
                    <option key={index} value={k.name}>{k.name}</option>
                )
            })
        }
    }

    componentDidMount = () => {
        localStorage.setItem('lastlocation', 'maintainalumni')
        this.props.actions.getEthnicities()
        this.props.actions.getGender()
        this.props.actions.getMaritalstatuses()
        this.props.actions.getPrefix()
        this.props.actions.getSuffix()
        this.props.actions.getOccupations()
        this.fetchDoNotContactOptions(this.props.profileinfo)
    }

    // Fetch the viewed person's alumni privacy options so the Do Not Contact
    // (Spark / Scouting America) checkboxes reflect their true saved values.
    fetchDoNotContactOptions = (profileinfo) => {
        const personGuid = profileinfo && profileinfo.profile && profileinfo.profile.personGuid
        if (personGuid && this.fetchedOptionsFor !== personGuid) {
            this.fetchedOptionsFor = personGuid
            this.props.actions.getOrUpdateAlumniPrivacyOptions(personGuid)
        }
    }

    componentWillReceiveProps = (nextprops) => {
        this.fetchDoNotContactOptions(nextprops.profileinfo)
        if (nextprops.profileinfo && this.props.profileinfo && nextprops.profileinfo.profile.personGuid == this.props.profileinfo.profile.personGuid && nextprops.profileinfo.extendedProfile && nextprops.profileinfo.extendedProfile.length > 0) {
            let hasEthnicity = nextprops.profileinfo.extendedProfile.find(attr => attr.attributeId == '1')
            if (hasEthnicity) {
                this.setState({
                    ethnicity: hasEthnicity
                })
            }
        }
    }

    CheckTheDate = (value, i) => {

        console.log("CheckTheDate " + value)
        var today = moment().format('MM/DD/YYYY'),
            enteredDate = value.split("/");

        enteredDate = new Date(enteredDate[2], enteredDate[1] - 1, enteredDate[0]).getTime();
        let isFuturedate = moment().isBefore(value);
        let isCurrentDate = moment(today).isSame(value);
        if (isFuturedate) {
            return this.setState({
                IsFutureDate: true,
                CustomDateErrMsg: 'The date Should not be in the future!'
            })
        }
        if (isCurrentDate) {
            return this.setState({
                IsFutureDate: true,
                CustomDateErrMsg: 'Date Of Birth should not be as a current Date!'
            })
        }
        else {
            return this.setState({
                IsFutureDate: false,
                CustomDateErrMsg: ''
            })
        }

    }

    renderCurrentAge = (dob) => {
        if (!dob) return '';
        const birthDate = moment(dob, ['YYYY-MM-DD', 'MM/DD/YYYY'], true);
        if (!birthDate.isValid()) return '';
        return moment().diff(birthDate, 'years');
    }

    handleSubmit = e => {
        e.preventDefault();
        if (!this.state.IsFutureDate) {
            this.props.form.validateFieldsAndScroll((err, values) => {
                if (!err) {
                    const { ethnicity } = this.state
                    const { suffixes, prefixes, ethnicities } = this.props

                    let suffix = suffixes.filter((data) => data.name == values.suffix)
                    let prefix = prefixes.filter((data) => data.name == values.prefix)
                    let suffixvalues = suffix.length ? parseInt(suffix[0].id) : ""
                    let prefixvalues = prefix.length ? parseInt(prefix[0].id) : ""
                    values.suffix = suffixvalues
                    values.prefix = prefixvalues

                    if (values.ethnicity) {
                        // let hasEthnicity  = profileinfo.extendedProfile.find(attr => attr.attributeId == '1')
                        if (ethnicity && (values.ethnicity != ethnicity.attributeVal) && ethnicities) {
                        values.ethnicity = ethnicities.find(each => each.short == values.ethnicity)
                        values.ethnicity.extendedProfileId = ethnicity.extendedProfileId
                    }
                }

                    this.props.actions.UpdateAlumniInfo(values, this.props.profileinfo.profile.personGuid, 'admin')
                }
            })
        }
    }

    cancelEditMode = e => {

        e.preventDefault();
        this.props.actions.getAlumniInfo(this.props.profileinfo.profile.personGuid, this.props.isspecialist ? "" : "admin")
        this.setState({
            CustomDateErrMsg: undefined,
            IsFutureDate: false
        })
    }

    // doNotContactFlagChange = (e) => {
    //     e.preventDefault();
    //     this.props.form.validateFieldsAndScroll((err, values) => {

    //     const extendedProfileId = this.props.profileinfo.extendedProfile.filter(obj => obj.attributeId == "25")[0].extendedProfileId;
        
    //     if (e.target.checked) {
    //         Modal.confirm({
    //             title: 'confirm',
    //             content: 'Are you sure you want to add do not contact flag?',
    //             okText: 'Confirm',
    //             cancelText: 'Cancel',
    //             onOk: () => {
    //                 this.props.actions.getOrUpdateAlumniPrivacyOptions(this.props.profileinfo.profile.personGuid, values, extendedProfileId)
    //             }
    //         })
    //     } else {
    //         Modal.confirm({
    //             title: 'Confirm',
    //             content: 'Are you sure you want to do not contact flag?',
    //             okText: 'Confirm',
    //             cancelText: 'Cancel',
    //             onOk: () => {
    //                 this.props.actions.getOrUpdateAlumniPrivacyOptions(this.props.profileinfo.profile.personGuid, values, extendedProfileId)
    //             }
    //         });
    //     }
    //     });
    // }

    doNotContactFlagChange = (e, flagKey) => {
    const checked = e.target.checked;
    const { profileinfo, privacysettingsOptions } = this.props;

    // AAG-1186: send both opt-out flags on every save, so changing one does not clear the other. A flag whose current value
    // isn't loaded yet is left out rather than sent as false, so an alum's existing opt-out is never switched off by accident.
    const doNotContactFlags = { [flagKey]: checked };
    ['sparkDirectoryOptOut', 'scoutingAmericaOptOut'].forEach(key => {
        if (key !== flagKey && privacysettingsOptions && typeof privacysettingsOptions[key] === 'boolean') {
            doNotContactFlags[key] = privacysettingsOptions[key];
        }
    });

    const label = flagKey === 'sparkDirectoryOptOut'
        ? 'Spark: Directory of Scouting Alumni'
        : 'Scouting America';

    Modal.confirm({
        title: 'Confirm',
        content: checked
            ? `Are you sure you want to opt out of ${label}?`
            : `Are you sure you want to remove the ${label} opt-out?`,
        okText: 'Confirm',
        cancelText: 'Cancel',
        onOk: () => {
            // AAG-1217: no extendedProfileId, so a Do Not Contact change does not also update the alum's privacy settings date
            // (that call failed with M400 for alumni without the date attribute, after the Success pop-up was already shown)
            this.props.actions.getOrUpdateAlumniPrivacyOptions(
                profileinfo.profile.personGuid,
                doNotContactFlags
            );
        }
    });
};

    DeceasedFlagChange = (e) => {
        e.preventDefault();
        if (e.target.checked) {
            Modal.confirm({
                title: 'Confirm',
                content: 'Are you sure want to add deceased flag?',
                okText: 'Confirm',
                cancelText: 'Cancel',
                onOk: () => {
                    this.props.actions.AddDeceasedFlag(this.props.profileinfo.profile.personGuid, true)
                }
            });
        } else {
            Modal.confirm({
                title: 'Confirm',
                content: 'Are you sure want to remove deceased flag?',
                okText: 'Confirm',
                cancelText: 'Cancel',
                onOk: () => {
                    this.props.actions.AddDeceasedFlag(this.props.profileinfo.profile.personGuid, false)
                }
            });
        }
    }

    SuspendFlagChange = (e) => {
        e.preventDefault();
        Modal.confirm({
            title: 'Confirm',
            content: 'Are you sure want to suspend the profile?',
            okText: 'Confirm',
            cancelText: 'Cancel',
            onOk: () => {
                this.props.actions.AddSuspendFlag(this.props.profileinfo.profile.personGuid, e.target.checked)
            }
        });
    }

    renderEditValues = (profileinfo) => {
        const Option = Select.Option;
        const FormItem = Form.Item;
        const dateFormat = 'YYYY/MM/DD';
        const { firstName } = this.state;
        const privacyOptions = this.props.privacysettingsOptions;
        let phone, email = '';
        if(profileinfo.phones && Array.isArray(profileinfo.phones.length) && profileinfo.phones.length > 0){
            phone = profileinfo.phones.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
        }
        if(profileinfo.emails && Array.isArray(profileinfo.emails.length) && profileinfo.emails.length > 0){
            email = profileinfo.emails.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
        }
        let hobby, ethinic, maritalstatus, privacysettings = ''
        // if (this.state.personGUID == '') {
        // this.setState({
        // personGUID: profileinfo.profile.personGuid
        // })
        // }
        if (profileinfo.extendedProfile) {
            profileinfo.extendedProfile.filter((data) => {
                if (data.attributeId == 1) {
                    ethinic = data.attributeVal
                }
                if (data.attributeId == 5) {
                    maritalstatus = data.attributeVal
                }
                if (data.attributeId == 16) {
                    hobby = data.attributeVal
                }
                if (data.attributeId == 17) {
                    privacysettings = data.attributeVal
                }
            })
        }
        const { getFieldDecorator, getFieldValue } = this.props.form;
        getFieldDecorator('phonekeys', { initialValue: [] });

        const {businessDetails, needToGetOtherOccupations} = this.state;

        return (

            <div className='edit-mode my-profile'>
                <Form onSubmit={this.handleSubmit} className="alumni-ui alumni-info-form">
                    <Row type='flex' justify='start'>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <Row type='flex' align='middle'>
                                <FormItem>
                                    <label className='field-label'> MEMBER ID </label>
                                    <label className='my-profile-field-value'> {profileinfo.profile.memberId} </label>
                                </FormItem>
                            </Row>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <Row type='flex' align='middle'>
                                <FormItem>
                                    <label className='field-label'> EAGLE ID </label>
                                    <label className='my-profile-field-value'> {profileinfo.profile.eagleId ? profileinfo.profile.eagleId : "-"} </label>
                                </FormItem>
                            </Row>
                        </Col>
                    </Row>
                    <Row type='flex' justify='start'>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <FormItem hasFeedback
                                label={
                                    <span>
                                        First Name&nbsp;
                                      <Tooltip title="If you believe there is a discrepancy, please contact Member Care at 972-580-2000">
                                            <Icon type="question-circle-o" />
                                        </Tooltip>
                                    </span>
                                }
                            >
                                {getFieldDecorator('firstname', {
                                    initialValue: profileinfo ? profileinfo.profile.firstName : "",
                                    rules: [{ required: true, message: 'Enter Alumni\'s First Name!' }],
                                })(
                                    <Input
                                        addonBefore={
                                            getFieldDecorator('prefix', {
                                                initialValue: profileinfo ? profileinfo.profile.title : "",
                                                rules: [{ required: false, message: 'Enter Alumni\'s Suffix!' }],
                                            })(
                                                <Select style={{ width: 70 }}>
                                                    {this.renderprefix()}
                                                </Select>
                                            )
                                        } placeholder="First Name" disabled={!this.props.isSuperAlumniAdmin} name="firstname" />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <FormItem hasFeedback
                                label={
                                    <span>
                                        Middle Name&nbsp;
                                      <Tooltip title="If you believe there is a discrepancy, please contact Member Care at 972-580-2000">
                                            <Icon type="question-circle-o" />
                                        </Tooltip>
                                    </span>
                                }
                            >
                                {getFieldDecorator('middlename', {
                                    initialValue: profileinfo ? profileinfo.profile.middleName : "",
                                    rules: [{ required: false, message: 'Enter Alumni\'s Middle Name!' }],
                                })(
                                    <Input placeholder="Middle Name" disabled={!this.props.isSuperAlumniAdmin} name="middlename" />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <FormItem
                                label={
                                    <span>
                                        Last Name&nbsp;
                                      <Tooltip title="If you believe there is a discrepancy, please contact Member Care at 972-580-2000">
                                            <Icon type="question-circle-o" />
                                        </Tooltip>
                                    </span>
                                }
                            >
                                {getFieldDecorator('lastname', {
                                    initialValue: profileinfo ? profileinfo.profile.lastName : "",
                                    rules: [{ required: true, message: 'Enter Alumni\'s Last Name!' }],
                                })(
                                    <Input addonAfter={
                                        getFieldDecorator('suffix', {
                                            initialValue: profileinfo ? profileinfo.profile.nameSuffix : "",
                                            rules: [{ required: false, message: 'Enter Alumni\'s Suffix!' }],
                                        })(
                                            <Select style={{ width: 70 }}>
                                                {this.rendersuffix()}
                                            </Select>
                                        )
                                    } placeholder="Last Name" disabled={!this.props.isSuperAlumniAdmin} name="lastname" />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <FormItem hasFeedback
                                label="Nickname"
                            >
                                {getFieldDecorator('nickname', {
                                    initialValue: profileinfo ? profileinfo.profile.nickName : "",
                                    rules: [
                                        { required: false, message: 'Enter Alumni\'s NickName!' },
                                        { max: 50, message: 'Nickname must be maximum 50 characters.' },
                                    ],
                                })(
                                    <Input placeholder="NickName" name="nickname" />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <FormItem hasFeedback
                                label={
                                    <span>
                                        Name displayed on Certificate&nbsp;
                                    </span>
                                }
                            >
                                {getFieldDecorator('certificatename', {
                                    initialValue: profileinfo ? profileinfo.profile.certificateName : "",
                                    rules: [
                                        { required: true, message: 'Enter Alumni\'s Certificate Name!' },
                                        { max: 50, message: 'Certificate name must be maximum 50 characters.' },
                                    ],
                                })(
                                    <Input placeholder="Certificate Name" />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                            <FormItem
                                hasFeedback
                                validateStatus={this.state.IsFutureDate ? "error" : undefined}
                                help={this.state.CustomDateErrMsg ? this.state.CustomDateErrMsg : undefined}
                                onBlur={(e) => this.CheckTheDate(e.target.value, 1)}
                                label={
                                    <span>
                                        Date of Birth&nbsp;
                                    </span>
                                }
                                onClick={() => this.setState({ scouts_DOB_MaskChar: '-' })}
                            >
                                {getFieldDecorator('dob', {
                                    initialValue: profileinfo ? (profileinfo.profile.dateOfBirth != '' ? moment(profileinfo.profile.dateOfBirth).format('MM/DD/YYYY') : '') : '',
                                    rules: [
                                        { required: true, message: 'Enter Alumni\'s Date of Birth!' },
                                        {
                                            pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                            message: `Please enter correct format MM/DD/YYYY Pattern`
                                        }
                                    ],
                                })(
                                    // <Input placeholder="Date Of Birth" />

                                    <InputMask
                                        mask="99/99/9999"
                                        placeholder='MM/DD/YYYY'
                                        alwaysShowMask
                                        maskChar={null}
                                        className={
                                        !this.props.isSuperAlumniAdmin
                                            ? "ant-input width-100 disabled-input"
                                            : "ant-input width-100"
                                        }
                                        // className="ant-input width-100"
                                        disabled={!this.props.isSuperAlumniAdmin}
                                        render={(ref, props) => (
                                            <Input style={
                                                !this.props.isSuperAlumniAdmin
                                                    ? { backgroundColor: '#f5f5f5', color: 'rgba(0,0,0,0.45)' }
                                                    : {}
                                                }
                                            />
                                        )}
                                    />

                                )}
                            </FormItem>
                        </Col>

                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                            <FormItem label={<span>Current Age&nbsp;</span>}>
                                <Input
                                    value={
                                        this.props.profileinfo && this.props.profileinfo.profile.dateOfBirth
                                            ? this.renderCurrentAge(this.props.profileinfo.profile.dateOfBirth)
                                            : "-"
                                    }
                                    disabled
                                />
                            </FormItem>
                        </Col>

                        <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                            <FormItem
                                label={
                                    <span>
                                        Gender&nbsp;
                                      <Tooltip title="If you believe there is a discrepancy, please contact Member Care at 972-580-2000">
                                            <Icon type="question-circle-o" />
                                        </Tooltip>
                                    </span>
                                }
                            >
                                {getFieldDecorator('gender', {
                                    initialValue: profileinfo ? profileinfo.profile.gender : "",
                                    rules: [{ required: true, message: 'Enter Alumni\'s Gender!' }],
                                })(
                                    <RadioGroup disabled onChange={this.onChange} value={this.state.value}>
                                        {this.renderGender()}
                                    </RadioGroup>
                                )}
                            </FormItem>
                        </Col>

                        <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                            <FormItem hasFeedback
                                label="Ethnicity"
                            >
                                {getFieldDecorator('ethnicity', {
                                    initialValue: this.state.ethnicity ? this.state.ethnicity.attributeVal : "",
                                    rules: [{ required: false, message: 'Enter Alumni\'s Ethnicity!' }],
                                })(
                                    <Select
                                        onChange={this.handleEthnicityChange}
                                        showSearch
                                        style={{ width: '100%' }}
                                        placeholder="Select an Ethnicity"
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {this.renderEthnicity()}
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                        
                    </Row>
                    <Row>
                        <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                            <FormItem label={""}>
                                {getFieldDecorator('deceased', {
                                    initialValue: "",
                                    rules: [{ required: false }],
                                })(
                                    <Checkbox checked={profileinfo ? profileinfo.profile.isDeceased : ""} onChange={this.DeceasedFlagChange}> Deceased</Checkbox>
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                            <FormItem label={""}>
                                {getFieldDecorator('suspend', {
                                    initialValue: "",
                                    rules: [{ required: false }],
                                })(
                                    <Checkbox checked={profileinfo ? profileinfo.profile.ineligibleFlag : ""} onChange={this.SuspendFlagChange}> Suspend Profile</Checkbox>
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={7} lg={7} xl={7}>
                            <div style={{ marginBottom: 4 }}>Do Not Contact</div>
                            <FormItem label={""} style={{ marginBottom: 0 }}>
                                <Checkbox
                                    checked={privacyOptions ? privacyOptions.sparkDirectoryOptOut : false}
                                    onChange={(e) => this.doNotContactFlagChange(e, 'sparkDirectoryOptOut')}
                                >
                                    Spark: Directory of Scouting Alumni
                                </Checkbox>
                            </FormItem>
                            <FormItem label={""} style={{ marginBottom: 0 }}>
                                <Checkbox
                                    checked={privacyOptions ? privacyOptions.scoutingAmericaOptOut : false}
                                    onChange={(e) => this.doNotContactFlagChange(e, 'scoutingAmericaOptOut')}
                                >
                                    Scouting America
                                </Checkbox>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row type='flex' className='btn-action' justify='space-around'>
                        <Col xs={23} sm={23} md={18} lg={18} xl={18}>
                            <Row type='flex' justify='space-around' style={{ alignItems: 'center' }}>
                                <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                                    <FormItem>
                                        <Button id="maintainpfle-pfle-cl-btn" className="myprofile-cancel-btn" onClick={(e) => this.cancelEditMode(e)}>CANCEL</Button>
                                    </FormItem>
                                </Col>
                                <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                                    <FormItem>
                                        <Button id="maintainpfle-pfle-su-btn" className="save-change-btn" style={{ margin: '0px', height: '56px' }} htmlType="submit" type="primary">SAVE CHANGES</Button>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
            </div>
        )
    }

    renderEditView = () => {
        if (this.props.updating) {
            return (<Spin indicator={LoadingIcon} className="loading-state" style={{ height: 420 }} tip="Updating Information..." />)
        }
        else if (this.props.loading  || this.props.updatingByAdmin) {
            return (<Spin indicator={LoadingIcon} className="loading-state" style={{ height: 420 }} tip="Loading Information..." />)
        }
        else if (this.props.profileinfo) {
            return this.renderEditValues(this.props.profileinfo)
        }
        else {
            return (<Spin indicator={LoadingIcon} className="loading-state" tip="Loading Information..." />)
        }
    }


    render() {
        return (
            <div>
                <Collapse defaultActiveKey={'1'} accordion style={{ border: 'none', backgroundColor: 'inherit' }}>
                    <Panel header="Constituent Personal Information" key="1" style={customPanelStyle}>

                        {this.renderEditView()}

                    </Panel>
                </Collapse>
            </div>
        )
    }
}


function mapStateToProps(state) {
    return {
        loading: state.alumniinforeducer.loading,
        profileinfo: state.alumniinforeducer.profileinfo,
        countries: state.countriesreducer.countries,
        ethnicities_loading: state.ethnicitiesreducer.loading,
        ethnicities: state.ethnicitiesreducer.ethnicities,
        statuses: state.maritalstatusreducer.status,
        genders: state.gendersreducers.genders,
        suffixes: state.suffixreducers.suffixes,
        prefixes: state.prefixreducers.prefixes,
        updating: state.alumniinforamtionreducer.loading,
        updatingByAdmin: state.alumniinfoupdatebyadminreducer.loading,
        occupationLoading: state.occupationsreducer.loading,
        occupations: state.occupationsreducer.occupations,
        isSuperAlumniAdmin: state.isadminreducer.isSuperAlumniAdmin,
        privacysettingsOptions: state.alumniPrivacyOptionsreducer.privacysettingsOptions,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}
const AlumniProfile = Form.create()(AlumniInfoForm);
export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(AlumniProfile);



// WEBPACK FOOTER //
// ./src/components/MaintainAlumni/alumniProfile.js